<script setup>
import { computed, defineProps } from "vue";
const props = defineProps({
  data: {
    type: Array,
    default: () => [],
  },
});

const data = computed(() =>
  props.data.length ? props.data : Array(8).fill({})
);
</script>
<template>
  <ul role="list" class="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3">
    <li
      class="col-span-1 h-60 rounded-lg relative overflow-hidden flex justify-center items-center"
      v-for="(item, index) in data"
      :key="index"
    >
      <img
        v-if="item && item.thumbnail"
        v-lazy="{
          src: item.thumbnail,
          error:
            'https://lms-v2-staging.s3-us-west-2.amazonaws.com/modules/default-thumbnail.jpg',
          loading:
            'https://via.placeholder.com/800x450?text=Thumbnail%20Loading...',
        }"
        alt=""
        class="w-full h-full object-cover"
      />
      <div v-if="item && !item.title" class="bg-untitled-gray-300 w-full h-full animate-pulse"></div>
      <div
        class="bg-gradient-to-t from-untitled-gray-700 absolute h-full w-full rounded-md flex justify-center items-center"
        v-if="item && item.title"
      >
        <p
          class="text-white font-bold text-3xl drop-shadow-2xl text-center line-clamp-2 absolute mx-4"
        >
          {{ item.title }}
        </p>
      </div>
    </li>
  </ul>
</template>

<style lang="scss" scoped></style>
